export const BUTTON_IMAGE_SIZE = 164;
export const LINK_IMAGE_SIZE = 196;
